import { render } from "./NeobuqEconomicForm.vue?vue&type=template&id=78e98461&scoped=true"
import script from "./NeobuqEconomicForm.vue?vue&type=script&lang=js"
export * from "./NeobuqEconomicForm.vue?vue&type=script&lang=js"

import "./NeobuqEconomicForm.vue?vue&type=style&index=0&id=78e98461&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e98461"]])

export default __exports__